export enum SessionActionType {
  FETCH_SESSION = "FETCH_SESSION",
  UPDATE_DEBITOR = "UPDATE_DEBITOR",
  UPDATE_LANGUAGE = "UPDATE_LANGUAGE",
  SET_SESSION_DATA = "SET_SESSION_DATA",
  SESSION_SYNC_FAIL = "SESSION_SYNC_FAIL",
  LOGOUT_SESSION = "LOGOUT_SESSION"
}
